export const environment = {
    production: false,
    https: 'https://',
    // baseurl_api: 'http://localhost:2005/backend-superapps/public/api/',
    baseurl_api: 'https://api.dev.superapps.adhivasindo.co.id/api/',
    baseurlStorage: 'https://ezgate.co.id/api_dev/',
    pathImg: '',
    path: '',
    auth: 'auth/login',
    me: 'auth/me',
    register: 'register',
    token: '',
    refresh_token: 'auth/refresh',
    img_default:
        'https://zeus.awh.co.id/awh_pos/images/k4m3dNY7iv416BvZCtKgMsagFVlI6kHTVIpcq8TiA-AhZlmGJYgTV4PBHHTiGDk9JLzi9Lh6kfGcirloU39_xfJcfF7FsDol4NmfI-IjzLUyerd7uXyZkaFuaEYGbITi',
    mqtt: {
        username: 'dhivapos',
        password: 'FurlaRasaMelon2024',
    },
};
